import { Helmet } from "react-helmet-async";

const SITE = "https://www.onedialafrica.com";

export default function SEO({ title, description, path = "/", image, schema }) {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} · OneDial Africa`
    : "OneDial Africa · Call Home for Less";
  const desc =
    description ||
    "OneDial Africa — a telecom + fintech super-app by Scitygate Telecom UK Ltd. International calling, eSIM, wallet, money transfer and bill payments across 50+ African destinations.";
  const img = image || `${SITE}/og-image.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="OneDial Africa" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
